import { BaseService } from "./BaseService";

const SeccionService = {
   async listarPorNombreSede(empresaId, nombreSede) {
    const respuesta = await BaseService.get("/seccion/listarPorNombreSede", {
      params: {
        empresaId:empresaId,
        nombreSede: nombreSede
      },
    });
    return respuesta.data;
  }, 
  async listarPorColaborador(login) {
    const respuesta = await BaseService.get("/seccion/colaborador", {
      params: {
        login: login,
      },
    });
    return respuesta.data;
  },
}
export default SeccionService;